<ion-content [fullscreen]="true">
  <div class="unrecoverable-error-container">
    <div class="logo-error-container">
      <div class="logo">
        <img src="/assets/branded/img/logo.svg" [alt]="'common.alt-image' | transloco" />
      </div>
      <div class="error-container">
        <div [innerHTML]="message || ('error.unrecoverable.default' | transloco)"></div>
        <div class="cta-container">
          <c-button type="primary-brand" (action)="retry()">
            {{ 'common.retry' | transloco }}
          </c-button>
          <c-button type="secondary-brand" (action)="logout()">
            {{ 'login.logout' | transloco}}
          </c-button>
        </div>
        
      </div>
    </div>
    <div class="hohr">
      <img src="assets/img/hohr-login.svg" [alt]="'common.alt-image' | transloco" />
    </div>
  </div>
</ion-content>
